import React, {useState} from 'react';
import { usePayments } from '../../../Data/Payments';
import ListViewLoading from '../../../Components/EmptyStates/ListViewLoading';
import CustomerPicker from '../../../Components/CustomerPicker';
import Search, { SearchBar, useSearch } from '../../../Components/Search';
import ListView from './ListView';
import Payment from './Payment';
import { useParams } from 'react-router-dom';
import { useDialogues } from '../../../Components/Dialogues';
import PaymentsSearch from './PaymentsSearch';
import filterSearchConditions from './filterSearchConditions';

const Payments = () => {

    return <Search persist="payments-search" hasConditionsFilter={filterSearchConditions}>
        <Inner />
    </Search>
}

const Inner = () => {
    const {paymentId} = useParams();
    const [openPayment, setOpenPayment] = useState(paymentId);
    const {searchDebounced, searchData, setSearchData, hasSearchConditions, liveSearch} = useSearch();
    const {payments, isEmpty, isLoading, matchPaymentToCustomer, removePaymentFromCustomer, refundPayment} = usePayments(searchDebounced, true);
    const [matchingPayment, setMatchingPayment] = useState(false);
    const [pickerPrompt, setPickerPrompt] = useState(false);
    const {confirm} = useDialogues();

    const matchCustomer = (payment) => {
        setMatchingPayment(payment.id);
        setPickerPrompt(payment.name);
    }

    const unmatchCustomer = (payment) => {
        confirm(
            {theme: 'danger', title: 'Unmatch payment', message: 'Are you sure you want to unmatch this payment? The payment will no longer be associated with a customer.'},
            () => removePaymentFromCustomer(payment.id, payment.customerId)
        )
    }

    if (!payments) {
        return <ListViewLoading count={5} layout="TwoRows" />;
    }

    return <>
        <SearchBar
            filterForm={<PaymentsSearch {...{searchData, setSearchData}} />}
            isLoading={isLoading}
            modalOptions={{
                title: 'Search payments',
                theme: 'primary',
                icon: 'MagnifyingGlass',
            }}
        />

        <ListView {...{payments: liveSearch(payments), setOpenPayment, matchCustomer, unmatchCustomer, refundPayment, isEmpty, hasSearchConditions}} />

        <Payment isOpen={!!openPayment}
            setIsOpen={setOpenPayment}
            matchCustomer={matchCustomer}
            unmatchCustomer={unmatchCustomer}
            paymentId={openPayment}
        />

        <CustomerPicker title={null}
            isOpen={!!matchingPayment}
            prompt={pickerPrompt}
            setIsOpen={() => setMatchingPayment(false)}
            onPicked={async (customerId) => {
                await matchPaymentToCustomer(matchingPayment, customerId)
                setMatchingPayment(false);
                setPickerPrompt(false);
            }}
        />
    </>
}

export default Payments;
